export default customElements.define('w-field-textarea', class FieldTextarea extends wealthify.componentBases.FieldText {

    constructor () {
        const config = {};

        config.styleSelector = 'c-field-textarea';
        config.fieldElement = `<textarea class="${config.styleSelector}__input" data-fieldinput></textarea>`;

        super(config);
    }

    static get observedProps() {
        return [
            new wealthify.Prop('rows', {
                default: 5,
                type: wealthify.propTypes.Number()
            })
        ];
    }

    get propCallbacks() {
        return {rows: () => {
            this.dom.fieldinput.setAttribute('rows', this.rows);
        }};
    }
});